import type { ExpandedImageItem, ExpandedImagePreview } from "./ExpandedImagePreview";

// Upstream's gallery registry keeps resolved images only while their DOM nodes
// are reachable. Gather on activation, so streaming never scans the document.
export const markdownImageItems = new WeakMap<Element, ExpandedImageItem>();

export function markdownImageGallery(
  element: Element,
  selected: ExpandedImageItem,
): ExpandedImagePreview {
  const scope = element.closest(".chat-markdown");
  const images: ExpandedImageItem[] = [];
  let index = -1;
  for (const image of scope?.querySelectorAll("img") ?? []) {
    const item = markdownImageItems.get(image);
    // Linked images keep the existing link's action, rather than joining an
    // unrelated gallery (badges and linked citations commonly contain images).
    if (!item || image.closest("a")) continue;
    if (image === element) index = images.length;
    images.push(item);
  }
  return index < 0 ? { images: [selected], index: 0 } : { images, index };
}
